export const PAGE_LOYALTY = "novotel::loyalty";
export const PAGE_MAGAZINE_HUB = "novotel::magazine::hub";
export const PAGE_MAGAZINE_ARTICLE = "novotel::magazine::article";
export const PAGE_MAGAZINE_CATEGORY = "novotel::magazine::category";
export const PAGE_LA_SUITE_NOVOTEL =
  "novotel::inspirations::family::la suite novotel";
